import JshModule from '@core/scripts/helper/jsh-module';

const {moduleScope} = JshModule('js-detector');

moduleScope.classList.remove('js-disabled');
moduleScope.classList.add('js-enabled');
